(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 50))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              const   swiperItems = document.querySelectorAll('.product-recommendations'),
              sliderOptions = $(swiperItems).attr('data-slider-options'),
               slideroptionConfig = $.parseJSON(sliderOptions);
               $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/embed/loader.js"); 
              this.innerHTML = recommendations.innerHTML;
              var recommedndationSlider = new Swiper(".product-recommendations", slideroptionConfig);
              window.initSwatchOptionImage();
              window.initVariantChanger(this);
              window.initTooltips([].slice.call(this.querySelectorAll('[data-bs-toggle="tooltip"]')));
              window.initCompare();
            }
    
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ul-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Discount code — Shopify's cart doesn't accept codes directly.
  // We POST to /discount/<code> which sets the cart attribute + redirects back to /cart.
  document.querySelectorAll('[data-ul-apply-discount]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = document.getElementById('ul-cart-discount');
      var code = (input && input.value || '').trim();
      if(!code){ input && input.focus(); return; }
      btn.disabled = true;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  });
  // Enter key submits the discount
  var di = document.getElementById('ul-cart-discount');
  if(di){
    di.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){
        e.preventDefault();
        var btn = document.querySelector('[data-ul-apply-discount]');
        if(btn) btn.click();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ul-featured-masterclass"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ul-feat-media]').forEach(function(media){
    var video = media.querySelector('[data-ul-feat-video]');
    var btn = media.querySelector('[data-ul-feat-play]');
    if(!video || !btn) return;
    var play = function(){
      media.classList.add('is-playing');
      video.controls = true;
      var p = video.play();
      if(p && p.catch) p.catch(function(){});
    };
    btn.addEventListener('click', function(e){ e.preventDefault(); play(); });
    video.addEventListener('ended', function(){ media.classList.remove('is-playing'); video.controls = false; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ul-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var h = document.querySelector('[data-ul-header]');
  if(!h) return;
  var onScroll = function(){ h.classList.toggle('is-scrolled', window.scrollY > 8); };
  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});

  var burger = h.querySelector('[data-ul-burger]');
  var menu = h.querySelector('[data-ul-mobile-menu]');
  if(burger && menu){
    burger.addEventListener('click', function(){
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      if(open){ menu.setAttribute('hidden',''); document.body.style.overflow=''; }
      else{ menu.removeAttribute('hidden'); document.body.style.overflow='hidden'; }
    });
    menu.addEventListener('click', function(e){
      var link = e.target.closest && e.target.closest('a');
      if(link){
        burger.setAttribute('aria-expanded','false');
        menu.setAttribute('hidden','');
        document.body.style.overflow='';
      }
    });
    var closeIfDesktop = function(){
      if(window.innerWidth > 1024){
        burger.setAttribute('aria-expanded','false');
        menu.setAttribute('hidden','');
        document.body.style.overflow='';
      }
    };
    window.addEventListener('resize', closeIfDesktop, {passive:true});
    window.addEventListener('orientationchange', closeIfDesktop, {passive:true});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ul-hero-video"] && !Shopify.designMode) return;
  try {
    
// Some browsers defer autoplay if the tab wasn't visible on load or if network
// throttling delays the metadata fetch. This forces a .play() attempt as soon
// as the element becomes visible + on any user interaction as a final fallback.
(function(){
  document.querySelectorAll('[data-ul-hero-video]').forEach(function(v){
    var tryPlay = function(){ var p = v.play(); if (p) p.catch(function(){}); };
    tryPlay();
    if (v.paused) requestAnimationFrame(tryPlay);
    // If autoplay was blocked, retry on first interaction anywhere on the page
    var kick = function(){ tryPlay(); if (!v.paused) { document.removeEventListener('click', kick); document.removeEventListener('touchstart', kick); } };
    document.addEventListener('click', kick, { passive: true });
    document.addEventListener('touchstart', kick, { passive: true });
    // Also retry when the tab becomes visible
    document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'visible') tryPlay(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ul-manifesto-hero"] && !Shopify.designMode) return;
  try {
    
// Reuse the hero autoplay force-play pattern for the manifesto video too.
(function(){
  document.querySelectorAll('.ul-manifesto__video[data-ul-hero-video]').forEach(function(v){
    var tryPlay = function(){ var p = v.play(); if (p) p.catch(function(){}); };
    tryPlay();
    if (v.paused) requestAnimationFrame(tryPlay);
    var kick = function(){ tryPlay(); if (!v.paused) { document.removeEventListener('click', kick); document.removeEventListener('touchstart', kick); } };
    document.addEventListener('click', kick, { passive: true });
    document.addEventListener('touchstart', kick, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ul-masterclass"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Hero video play button — handles both uploaded video AND external YouTube/Vimeo
  document.querySelectorAll('[data-ul-mc-play], .ul-mc__play').forEach(function(btn){
    btn.addEventListener('click', function(){
      var poster = btn.closest('.ul-mc__hero-poster');
      if(!poster) return;
      var v = poster.querySelector('video');
      if(v){
        // Uploaded HTML5 video — unmute + add native controls (mute toggle, fullscreen, seek)
        v.muted = false;
        v.loop = false;
        v.setAttribute('controls', '');
        v.controls = true;
        if(v.paused) v.play();
        btn.style.display = 'none';
        var tint = poster.querySelector('.ul-mc__hero-poster-tint');
        if(tint) tint.style.display = 'none';
        return;
      }
      var placeholder = poster.querySelector('[data-ul-mc-embed-url]');
      if(placeholder){
        var url = placeholder.dataset.ulMcEmbedUrl;
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        var iframe = document.createElement('iframe');
        iframe.src = url + sep + 'autoplay=1&rel=0&modestbranding=1';
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        iframe.className = 'ul-mc__hero-video';
        iframe.style.border = '0';
        placeholder.replaceWith(iframe);
        var img = poster.querySelector('[data-ul-mc-poster]');
        if(img) img.style.display = 'none';
        var tint = poster.querySelector('.ul-mc__hero-poster-tint');
        if(tint) tint.style.display = 'none';
        btn.style.display = 'none';
      }
    });
  });

  // Expand-to-fullscreen for uploaded videos (double-click OR dedicated button if we add one)
  document.querySelectorAll('.ul-mc__hero-video').forEach(function(v){
    if(v.tagName !== 'VIDEO') return;
    v.addEventListener('dblclick', function(){
      if(document.fullscreenElement){ document.exitFullscreen(); }
      else if(v.requestFullscreen){ v.requestFullscreen(); }
      else if(v.webkitRequestFullscreen){ v.webkitRequestFullscreen(); }
    });
  });

  // Bottom "Ready to level up?" enroll button — actually add to cart (not just scroll)
  document.querySelectorAll('[data-ul-mc-final-enroll]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var form = document.getElementById('ul-mc-form');
      if(!form) return;
      // Trigger form submit (Hongo's cart drawer will intercept + show notification)
      var submitter = form.querySelector('button[type="submit"], [name="add"]');
      if(submitter) submitter.click();
      else form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  // Hero "Enroll now" — add to cart and go straight to /cart
  document.querySelectorAll('[data-ul-mc-scroll-cta]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var form = document.getElementById('ul-mc-form');
      if(!form) return;
      var fd = new FormData(form);
      fetch('/cart/add.js', { method:'POST', body:fd, headers:{ 'Accept':'application/json' } })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); window.location.href = '/cart'; })
        .catch(function(){
          var submitter = form.querySelector('button[type="submit"], [name="add"]');
          if(submitter) submitter.click();
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ul-mc"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Hero video play button
  document.querySelectorAll('[data-ul-mc-play], .ul-mc__play').forEach(function(btn){
    btn.addEventListener('click', function(){
      var v = btn.closest('.ul-mc__hero-poster')?.querySelector('video');
      if(!v) return;
      if(v.paused){ v.muted = false; v.play(); btn.style.opacity = 0; }
    });
  });

  // Bottom "Ready to level up?" enroll button — actually add to cart (not just scroll)
  document.querySelectorAll('[data-ul-mc-final-enroll]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var form = document.getElementById('ul-mc-form');
      if(!form) return;
      // Trigger form submit (Hongo's cart drawer will intercept + show notification)
      var submitter = form.querySelector('button[type="submit"], [name="add"]');
      if(submitter) submitter.click();
      else form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  // Hero "Enroll now" — add to cart and go straight to /cart
  document.querySelectorAll('[data-ul-mc-scroll-cta]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var form = document.getElementById('ul-mc-form');
      if(!form) return;
      var fd = new FormData(form);
      fetch('/cart/add.js', { method:'POST', body:fd, headers:{ 'Accept':'application/json' } })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); window.location.href = '/cart'; })
        .catch(function(){
          var submitter = form.querySelector('button[type="submit"], [name="add"]');
          if(submitter) submitter.click();
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
